<div class="left">
  <a routerLink="/" aria-label="Home Page">
    <app-logo [size]="38"></app-logo>
    <app-site-name></app-site-name>
  </a>
  <app-main-menu-button></app-main-menu-button>
</div>

<nav role="navigation">
  <ul>
    <li><a [routerLink]="['collection', newArrivalsNo]">New</a></li>
    <li><a [routerLink]="['collection', bestSellersNo]">Best Sellers</a></li>
    @for (category of categories; track $index) {
    <li>
      <button (click)="setActiveCategory(category)">{{category.name}}</button>
    </li>
    }
  </ul>
</nav>
<div class="right">
  <app-search-button></app-search-button>
  <app-shopping-cart-button></app-shopping-cart-button>
  <app-auth-button></app-auth-button>
</div>

@if (activeCategory) {
<div class="dropdown" @dropdown>
  <app-main-toolbar-dropdown
    [category]="activeCategory"
  ></app-main-toolbar-dropdown>
</div>
}
